import { createReducer } from '@reduxjs/toolkit';
import z from 'zod';
import { locationSetHeadingSource } from './actions.js';

/**
 * Where the heading beam on the located position comes from:
 *
 * - `none` — no beam at all.
 * - `gps` — course over ground, which the fix carries for free but only while
 *   the user actually moves.
 * - `compass` — the device magnetometer, which also works standing still, but
 *   needs a permission grant on iOS and varies wildly in quality. Falls back to
 *   the course when the compass is missing or contradicts it.
 */
export const HeadingSourceSchema = z.enum(['none', 'gps', 'compass']);

export type HeadingSource = z.infer<typeof HeadingSourceSchema>;

/**
 * Persisted locating preferences. Separate from the transient `location` slice,
 * which `toggleLocate` resets on every toggle.
 */
export interface LocationSettingsState {
  headingSource: HeadingSource;
}

export const locationSettingsInitialState: LocationSettingsState = {
  headingSource: 'gps',
};

export const locationSettingsReducer = createReducer(
  locationSettingsInitialState,
  (builder) =>
    builder.addCase(locationSetHeadingSource, (state, action) => {
      state.headingSource = action.payload;
    }),
);
